import type { ErrorType } from './types'

export function classifyError(error: unknown): ErrorType {
  const err =
    error && typeof error === 'object'
      ? (error as { message?: string; code?: number | string })
      : undefined
  const message = err?.message?.toLowerCase() ?? (typeof error === 'string' ? error.toLowerCase() : '')
  const code = err?.code

  if (
    code === 4001 ||
    message.includes('user rejected') ||
    message.includes('user disapproved') ||
    message.includes('user denied') ||
    message.includes('exited_auth_flow') ||
    message.includes('oauth_user_denied')
  ) {
    return 'user_rejected'
  }

  if (message.includes('insufficient funds for gas')) {
    return 'insufficient_gas'
  }

  if (message.includes('insufficient balance')) {
    return 'insufficient_balance'
  }

  if (message.includes('slippage') || message.includes('insufficient_output_amount')) {
    return 'slippage'
  }

  if (message.includes('timeout')) {
    return 'timeout'
  }

  if (
    message.includes('could not detect network') ||
    message.includes('network error') ||
    message.includes('failed to fetch')
  ) {
    return 'rpc_error'
  }

  if (message.includes('execution reverted') || message.includes('revert')) {
    return 'contract_revert'
  }

  return 'unknown'
}
